import moment from "moment";
import {
  ADD_INSTRUCTOR,
  CLASES_RECIBIDAS,
  CLASS_TYPES_RECIBIDOS,
  CREATE_CLASE,
  HIDE_SPINNER,
  REMOVE_INSTRUCTOR,
  RESERVATIONS_RECIBIDAS,
  SEMANAS_RECIBIDAS,
  SET_CLASE,
  SET_END_DATE,
  SET_MONTH,
  SET_PROPIEDAD_CLASE,
  SET_START_DATE,
  SET_VIEW,
  SET_WEEK,
  SHOW_SPINNER,
  TOTAL_RECIBIDO,
} from "../types";

const schema = {
  class_instructor_id: "nueva",
  description: "",
  location_id: "",
  class_type_id: "",
  capacity: "",
  class_date: "",
  is_virtual_class: false,
  is_special_event: false,
  class_instructors: [],
};

const ClassInstructorReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_VIEW:
      return { ...state, view: payload };
    case SEMANAS_RECIBIDAS:
      return { ...state, days: payload };
    case RESERVATIONS_RECIBIDAS:
      return { ...state, reservations: payload };
    case SET_CLASE:
      return { ...state, clase: payload };
    case SET_PROPIEDAD_CLASE:
      const clase = { ...state.clase };
      const { key, value } = payload;
      clase[key] = value;
      return { ...state, clase };
    case CREATE_CLASE:
      return {
        ...state,
        clase: {
          ...schema,
          class_date: moment.utc().local().format("YYYY-MM-DD HH:mm:ss"),
        },
      };
    case CLASS_TYPES_RECIBIDOS:
      return { ...state, class_types: payload };
    case CLASES_RECIBIDAS:
      return { ...state, clases: payload };
    case TOTAL_RECIBIDO:
      return { ...state, total: payload };
    case ADD_INSTRUCTOR: {
      const { class_instructors } = state.clase;
      if (Array.isArray(class_instructors)) {
        class_instructors.push({
          instructor: payload,
          instructor_id: payload.instructor_id,
        });
      }
      return { ...state, clase: { ...state.clase, class_instructors } };
    }
    case REMOVE_INSTRUCTOR: {
      const { class_instructors } = state.clase;
      if (Array.isArray(class_instructors)) {
        const index = class_instructors.findIndex(
          (instructor) => String(instructor.instructor_id) === String(payload)
        );
        if (index !== -1) {
          class_instructors.splice(index, 1);
        }
      }
      return { ...state, clase: { ...state.clase, class_instructors } };
    }
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SET_WEEK:
      return { ...state, selectedWeek: payload };
    case SET_MONTH: {
      return { ...state, month: payload };
    }
    case SET_START_DATE:
      return { ...state, start_date: payload };
    case SET_END_DATE:
      return { ...state, end_date: payload };
    default:
      return { ...state };
  }
};

export default ClassInstructorReducer;
